import foreignKeyClass from "../foreignKeyClass";

class tuoteClass {
  laskuttajaAsiakasId;
  tuoteId;
  nimike;
  lisäNimike;
  yksikkö;
  tuoteTypeId;
  foreignKeys;
  määräKaava;
  aktiivinen;
  kustannusPaikkaEval;
  alv;
  hinta;
  orderNum;
  tuoteCatTypeId;
  tuoteCatTypeName;
  kommentti;
  constructor(laskuttajaAsiakasId, tuoteTypeId) {
    this.laskuttajaAsiakasId = laskuttajaAsiakasId;
    this.tuoteId = null;
    this.nimike = "uusi tuote";
    this.lisäNimike = "";
    this.yksikkö = "";
    this.tuoteTypeId = tuoteTypeId;
    this.foreignKeys = [new foreignKeyClass(this.tuoteId)];
    this.määräKaava = "";
    this.aktiivinen = true;
    this.kustannusPaikkaEval = null;
    this.alv = import.meta.env.VITE_DEFAULT_ALV_PROM / 100;
    this.hinta = 0;
    this.orderNum = 0;
    this.tuoteCatTypeId = 0;
    this.tuoteCatTypeName = "";
    this.kommentti = "";
  }

  static getForeignKey = (tuote, foreignKeySourceId) => {
    if (!tuote.foreignKeys) return "";
    for (let i = 0; i < tuote.foreignKeys.length; i++) {
      if (tuote.foreignKeys[i].foreignKeySourceId === foreignKeySourceId) {
        const _foreignKey = tuote.foreignKeys[i].foreignKey;
        // make as null if undefined
        if (!_foreignKey) tuote.foreignKeys[i].foreignKey = "";
        if (_foreignKey == "undefined") tuote.foreignKeys[i].foreignKey = "";
        return tuote.foreignKeys[i];
      }
    }
    return "";
  };
}

export default tuoteClass;

export class laskuTuoteClass {
  laskuttajaAsiakasId;
  maksajaAsiakasId;
  laskuTuote;
  constructor(laskuttajaAsiakasId, maksajaAsiakasId) {
    this.laskuttajaAsiakasId = laskuttajaAsiakasId;
    this.maksajaAsiakasId = maksajaAsiakasId;
    this.laskuTuote = new tuoteClass(laskuttajaAsiakasId, 1); // 1 = tuoteType keikkaLaskuRivi
  }
}
